<template>
<b-container style="max-width: 1200px !important">
<b-row>
<b-col cols="12" class="marginaltop">
    <b-row class="justify-content-center marginalbotsm">
        <b-col cols="auto">
            <b-button @click="activePlugin = 'noDRM'" :variant="(activePlugin === 'noDRM') ? 'greenw':'msstreamblue'">{{$ml.get('examplenodrm')}}</b-button>
            &nbsp;
            <b-button @click="activePlugin = 'withDRM'" :variant="(activePlugin !== 'noDRM') ? 'greenw':'msstreamblue'" >{{$ml.get('exampledrm')}}</b-button>
        </b-col>
    </b-row>

    <b-row class="mt-2">
    <vue-markdown :show="activePlugin === 'noDRM'" style="overflow: auto;" class="col-xl-7 col-12" :style="(activePlugin === 'withDRM')?'display: none' : ''" @rendered="onrender">
Example of index.html using Shaka player and integrating **QUANTEEC** without DRM.


``` html
&lt;head>
    &lt;script src="https://ajax.googleapis.com/ajax/libs/shaka-player/4.0.0/shaka-player.compiled.js">&lt;/script>
    &lt;script src="https://files.quanteec.com/quanteec/latest/quanteec-shaka.min.js">&lt;/script> &lt;!-- 1-include QUANTEEC script-->
&lt;/head>

&lt;body>
    &lt;video id="videoplayer" width="854" height="480" controls>&lt;/video>

    &lt;script>
        document.addEventListener("DOMContentLoaded", function () {
            var videoSource = "https://my.server.com/videoSource.mpd";

            // 2-Adjust QUANTEEC configuration
            var configuration = {
                quanteecKey: "{{streamKey}}",
                videoID: "customVideoID" // [Optional but recommended] String --> specific name to identify a video. Useful if the videosource url contains a token which is different for every users. Default: the videoSource value is used.
            };

            const video = document.getElementById('videoplayer');
            const shakaplayer = new shaka.Player(video);

            // 3-Link QUANTEEC to shaka player right *after* the creation of the shaka player instance
            var quanteec = new Quanteec(configuration, shakaplayer);

            shakaplayer.load(videoSource);

        });
    &lt;/script>
&lt;/body>
```
    </vue-markdown>


    <vue-markdown :show="activePlugin === 'withDRM'" style="overflow: auto;" class="col-7" :style="(activePlugin === 'noDRM')?'display: none' : ''" @rendered="onrender">
Example of index.html using shaka player and integrating **QUANTEEC** with DRM. The documentation can be found [here](https://shaka-player-demo.appspot.com/docs/api/tutorial-drm-config.html)


``` html
&lt;head>
    &lt;script src="https://ajax.googleapis.com/ajax/libs/shaka-player/4.0.0/shaka-player.compiled.js">&lt;/script>
    &lt;script src="https://files.quanteec.com/quanteec/latest/quanteec-shaka.min.js">&lt;/script> &lt;!-- 1-include QUANTEEC script-->
&lt;/head>

&lt;body>
    &lt;video id="videoplayer" width="854" height="480" controls>&lt;/video>

    &lt;script>
        document.addEventListener("DOMContentLoaded", function () {
            var videoSource = "https://my.server.com/videoSource.mpd";

            // 2-Adjust QUANTEEC configuration
            var configuration = {
                quanteecKey: "{{streamKey}}",
                videoID: "customVideoID" // [Optional but recommended] String --> specific name to identify a video. Useful if the videosource url contains a token which is different for every users. Default: the videoSource value is used.
            };

            const video = document.getElementById('videoplayer');
            const shakaplayer = new shaka.Player(video);

            // 3-Link QUANTEEC to shaka player right *after* the creation of the shaka player instance
            var quanteec = new Quanteec(configuration, shakaplayer);

            // DRM part
            player.configure({
                    drm: {
                        //logLicenseExchange:true,
                        servers: { 
                            'com.widevine.alpha': "URL_TO_LICENSE_SERVER",
                            'com.microsoft.playready' : "URL_TO_LICENSE_SERVER",
                            'com.apple.fps.1_0' } : "URL_TO_LICENSE_SERVER",
                    },
                });
            // End DRM part

            shakaplayer.load(videoSource);

        });
    &lt;/script>
&lt;/body>
```
    </vue-markdown>

    <ConfigDoc class="col-xl-5 col-12">
    </ConfigDoc>
    </b-row>
</b-col>
</b-row>
</b-container>
</template>
<script>
import ConfigDoc from '@/components/documentation/plugins/ConfigDoc.vue';
import VueMarkdown from 'vue-markdown';
import Prism from 'prismjs';
import 'prismjs/themes/prism-twilight.css';
export default {
  name: 'ShakaPlayer',
  data: function() {
    return {
     activePlugin:"noDRM",     
    }
  },
  props: [
      "streamKey"
  ],
  components: {
      VueMarkdown,
      ConfigDoc
  },
  mounted: function() {

    this.$nextTick(() => {
        Prism.highlightAll()
      });  
  },
  methods: {
      onrender() {
        this.$nextTick(() => {
        Prism.highlightAll()
      });  
     }        
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

</style>